import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence harmless "ResizeObserver loop" warning that CRA dev overlay reports as a
// runtime error. It is triggered by Radix UI Select layout measurement inside Dialog
// and never affects production builds.
const RESIZE_OBSERVER_WARNINGS = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener("error", (e) => {
  if (RESIZE_OBSERVER_WARNINGS.some((msg) => e.message?.includes(msg))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
